import { PartnerFinances } from 'types/state';
import { M8PartnerBalance } from 'services/production/types';

export const normalizeM8PartnerBalance = (
  m8PartnerBalance: M8PartnerBalance
) => ({
  toPartnerFinances(): PartnerFinances {
    return {
      balanceAmount: m8PartnerBalance.balance,
      earnedAmount: m8PartnerBalance.totalEarned,
      paidAmount: m8PartnerBalance.totalPayed,
    };
  },
});
